
/* ========================================================================== 
   HARDWARE SEARCH INDEX (/database/js/hardware-search-index.js)
   New-module boundary keeps staggered/cached deployments link-safe.
   ========================================================================== */

import { normalizeHardwareIdentity } from './hardware-index.js?v=20260819-audit2';

function normalizeHardwareSearchText(value) {
  return String(value || '')
    .normalize('NFKC')
    .toLowerCase()
    .replace(/&/g, ' and ')
    .replace(/[^a-z0-9]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

/** Search profile keeps dimensions/numbers so queries such as "4090 337" work. */
export function createHardwareSearchProfile(...values) {
  const normalized = normalizeHardwareSearchText(values.filter(Boolean).join(' '));
  return {
    normalized,
    tokens: normalized ? normalized.split(' ').filter(Boolean) : []
  };
}

/** Identity profile deliberately strips dimension annotations for fuzzy restore. */
export function createHardwareIdentityProfile(value) {
  const normalized = normalizeHardwareIdentity(value);
  return {
    normalized,
    tokens: normalized ? normalized.split(' ').filter(Boolean) : []
  };
}
